export const Environment = {
  production: process.env.PRODUCTION
};
